import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { CarouselSelection } from './CarouselSelection';
import { CarouselEventNavigationState } from 'src/domains/layouts/webview/components/eventNavigation/CarouselEventNavigationState';
import { useCommon } from 'src/domains/common/Common';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';

interface PropsType {
    state: CarouselEventNavigationState;
}

export const CarouselEventNavigationCompetition = observer('CarouselEventNavigationCompetition', (props: PropsType) => {
    const common = useCommon();
    const languagesState = LanguagesState.get(common);
    return (
        <CarouselSelection
            options={props.state.competitionState.competitionsData}
            placeholder={languagesState.getTranslation('events.navigation.competition', 'Select competition')}
            active={props.state.competitionState.active}
            type='competition'
        />
    );
});
